import { Controller } from "@hotwired/stimulus";
import { onCustomizationRendered, onPageChange } from "./customization/event";
import CustomizationRequest from "./customization/request";

// Connects to data-controller="site-builder--site-owner-controller"
export default class extends Controller {
  static targets = ["edit", "new", "copy", "list"];

  connect() {
    /*
        Render the site owner bar when site builder loads (once) and then
        after every page change
     */
    onCustomizationRendered(this.render, { once: true });
    onPageChange(this.render);
  }

  async copyLink(e) {
    e.preventDefault();
    const url = CustomizationRequest.getPageUrl();
    await navigator?.clipboard?.writeText(url);

    const copyElement = this.copyTarget.querySelector(".copy");
    const copiedElement = this.copyTarget.querySelector(".copied");
    copyElement.classList.add("hidden");
    copiedElement.classList.remove("hidden");
    setTimeout(() => {
      copyElement.classList.remove("hidden");
      copiedElement.classList.add("hidden");
    }, 2000);
  }

  render = () => {
    this.buttonData = CustomizationRequest.getSiteOwnerBarPayload();
    if (this.buttonData) {
      this.#draw();
    }
  };

  #draw() {
    const buttons = Object.entries(this.buttonData);
    const [editLabel, editLink] = buttons[0];
    this.editTarget.lastChild.textContent = editLabel;
    this.editTarget.href = editLink;

    // There are cases when the `new` button is not available.
    if (buttons.length > 1) {
      this.newTarget.classList.remove('hidden')

      const [newLabel, newLink] = buttons[1];
      this.newTarget.lastChild.textContent = newLabel;
      this.newTarget.href = newLink;
    } else {
      this.newTarget.classList.add('hidden')
    }

    this.listTarget.classList.remove("disabled");
  }
}
